import { Col, Container, Row } from "react-bootstrap";
import { CstmPagination, Rating } from "../../../../components/Common/Common";

// img
import user from "../../../../Assets/images/user.png";
import { Link, useParams } from "react-router-dom";
import MapView from "./MapView";

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { GET_MANAGE_BOOKING_DETAILS } from "../../../../services/ApiCalls";
import StarRating from "../../CustomerDetail/Component/StarComp";

const DriverBookingDetail = () => {
  const { id } = useParams();

  const [bookingDetails, setBoookingDetails] = useState();
  const [location, setLocation] = useState({
    startLocation: {
      lat: 0,
      lng: 0,
    },
    endLocation: {
      lat: 0,
      lng: 0,
    },
  });
  const getBookingDetails = async () => {
    try {
      const res = await GET_MANAGE_BOOKING_DETAILS(id);
      if (res?.data?.status === "success") {
        setBoookingDetails(res?.data?.data);
        setLocation({
          startLocation: {
            lng: res?.data?.data?.startLocation?.coordinates[0],
            lat: res?.data?.data?.startLocation?.coordinates[1],
          },
          endLocation: {
            lng: res?.data?.data?.endLocation?.coordinates[0],
            lat: res?.data?.data?.endLocation?.coordinates[1],
          },
        });
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) getBookingDetails();
  }, [id]);
  return (
    <>
      <section
        className="bookingDetial py-3 position-relative"
        style={{ zIndex: 9 }}
      >
        <Container>
          <Row className="align-items-start">
            <Col lg="12" className="my-2">
              <Link to="/manage-driver/registered-driver/view" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="6" className="my-2 sticky-top" style={{ top: 80 }}>
              {/* <iframe
                style={{ height: "90vh", borderRadius: 20 }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.656284036987!2d76.68995807466014!3d30.699945487218038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fef919b7bbba9%3A0xedc14bb423e0f91a!2sSuffescom%20Solutions!5e0!3m2!1sen!2sin!4v1712126148793!5m2!1sen!2sin"
                className=" border-0 w-100"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe> */}
              <div className="mapWrpper" style={{ height: 500 }}>
                <MapView
                  startLocation={location?.startLocation}
                  endLocation={location?.endLocation}
                />
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <div className="py-2"></div>
              <div className="py-2">
                <div className="cardCstm p-3 border rounded">
                  <div className="top d-flex align-items-start justify-content-between gap-10">
                    <div className="left">
                      <h4 className="m-0 text-muted fw-bold pb-2">
                        Given Rating and Review
                      </h4>
                      {/* <Rating size={18} /> */}
                    </div>
                  </div>
                  <div className="contentBody py-2">
                    <div>
                      {bookingDetails?.reviews?.given?.length > 0 ? (
                        bookingDetails.reviews.given.map((review, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: "16px",
                              margin: "8px 0",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <h6>Sr No. {index + 1}</h6>
                            <p className="d-flex">
                              {/* <strong>Rating:</strong> {review.rating} */}
                              Rating:
                              <StarRating averageRating={review?.rating} />
                            </p>
                            <p className="">
                              {/* <strong>Review:</strong> {review.review} */}
                              Rating: - {review.review}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>No given reviews available.</p>
                      )}
                    </div>
                    {/* <div className="d-flex justify-content-end mt-3">
                      <CstmPagination />
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="py-2">
                <div className="cardCstm p-3 border rounded">
                  <div className="top d-flex align-items-start justify-content-between gap-10">
                    <div className="left">
                      <h4 className="m-0 text-muted fw-bold pb-2">
                        Received Rating and Review
                      </h4>
                      {/* <Rating size={18} /> */}
                    </div>
                    {/* <div className="right">
                      <h4 className="fw-sbold themeBlue">4.5/5</h4>
                    </div> */}
                  </div>
                  <div className="contentBody py-2">
                    <div>
                      {bookingDetails?.reviews?.received?.length > 0 ? (
                        bookingDetails.reviews.received.map((review, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              padding: "16px",
                              margin: "8px 0",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <h6>Sr No. {index + 1}</h6>
                            <p>
                              {" "}
                              Booking Number : {review.order.bookingNumber}
                            </p>
                            <p className="d-flex">
                              {/* <strong>Rating:</strong> {review.rating} */}
                              Rating:
                              <StarRating averageRating={review?.rating} />
                            </p>
                            <p className="">
                              <strong>Review: </strong> {review.review}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>No received reviews available.</p>
                      )}
                    </div>
                    {/* <div className="d-flex justify-content-end mt-3">
                      <CstmPagination />
                    </div> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverBookingDetail;
